<template>
  <div ref="whole_page" style="text-align: left;">
    <loading-view :isCardActive="loadingView" />
    <error-loading-view :isCardActive="errorLoadingView" @retry="loadTask" @hideView="errorLoadingView = false" />
    <div v-if="$siteTypeId() != 1 && !loadingView && !errorLoadingView">
      <vx-card class="mb-4">
        <div class="vx-row xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2">
          
          <div v-if="outcome" class="vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2">
            <h4>Outcome</h4>
            <table >
              <tr><td><p>Name:</p></td><td><p style="font-weight: 700">{{outcome.name}}</p></td></tr>
              <tr><td><p>Description:</p></td><td><p style="font-weight: 700">{{outcome.description}}</p></td></tr>
            </table>
          </div>
          <div v-else  class="vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2">
            <h4>Outcome</h4>
            <p style="font-weight: 700">N/A</p>
          </div>
          
          <div  v-if="standard" class="vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2">
            <h4>Unit Standard</h4>
              <table>
                <tr><td><p>Name:</p></td><td><p style="font-weight: 700">{{standard.name}}</p></td></tr>
                <tr><td><p>Description:</p></td><td><p style="font-weight: 700">{{standard.description}}</p></td></tr>
              </table>
          </div>
          <div v-else  class="vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2">
            <h4>Unit Standard</h4>
            <p style="font-weight: 700">N/A</p>
          </div>
        </div>
        <div class="vx-row mt-3">
          <div class="vx-col">
            <h4>Remedial Count <p>{{`${remedialCount}/${remedialCount >2 ? `${remedialCount}` : '2'}`}}</p></h4>
          </div>
        </div>
      </vx-card>
    </div>
    <!-- Quiz -->
    <div v-if="taskResults && !taskResults.quizId && !taskResults.uploadTaskId && !taskResults.videoCaptureTaskId">
      <div class="mb-3" v-for="(result, index) in taskResults.questions" :key="index">
        <div v-if="index == 0">
          <ispring-quiz-info-view :studentName="taskResults.fullname" :isCardActive="ispringQuizInfoView" :quizInfo="taskResults" :newScore="ispringTotalScore" />
        </div>
        <div v-if="result.questionType == 'MultipleChoice'">
          <multiple-choice-question   :isCardActive="multipleChoiceQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="result.questionType == 'MultipleResponse'">
          <multiple-response-question   :isCardActive="multipleResponseQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="result.questionType == 'Text'">
          <text-question   :isCardActive="textQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="result.questionType == 'Sequence'">
          <sequence-question   :isCardActive="sequenceQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="result.questionType == 'Matching'">
          <matching-question   :isCardActive="matchingQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="result.questionType == 'Sentence' || result.questionType == 'MultipleChoiceText' || result.questionType == 'WordBank'">
          <sentence-question   :isCardActive="sentenceQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="result.questionType == 'LikertScale'">
          <likert-scale-question   :isCardActive="likertScaleQuestion" :question="result" :quizType="taskResults.quizSettings.quizType" :predefinedComments="predefinedComments" />
        </div>
      </div>
    </div>
    <div v-else-if="taskResults && taskResults.quizId">
      <div v-for="(answer, answerIndex) in taskResults.answers" :key="answerIndex">
        <div v-if="answerIndex == 0">
          <quiz-info-view :studentName="taskResults.fullname"  :isCardActive="quizInfoView" :quiz="taskResults.quizDetails" :info="taskResults" :newScore="quizAchievedMarks" :freeTextTotal="quizTotalMarks" :newQuizTotal="quizTotalMarks" />
        </div>
        <div v-if="answer.questionType == 1"> <!-- MultipleChoiceSingleAnswer -->
          <mcss-question  :isCardActive="mcssQuestion" :question="taskResults" :answer="answer" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="answer.questionType == 2"> <!-- MultipleChoiceMultipleAnswers -->
          <mcms-question :isCardActive="mcmsQuestion" :question="taskResults" :answer="answer" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="answer.questionType == 3"> <!-- FreeText -->
          <free-text-question   :isCardActive="freeTextQuestion" :question="taskResults" :answer="answer" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="answer.questionType == 4"> <!-- Table -->
          <table-question  :isCardActive="tableQuestion" @loadTask="loadTask" :question="taskResults" :answer="answer" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="answer.questionType == 5"> <!-- Drag And Drop -->
          <drag-and-drop  :isCardActive="dragAndDropQuestion" :question="taskResults" :answer="answer" :predefinedComments="predefinedComments" />
        </div>
        <div v-else-if="answer.questionType == 6"> <!-- Upload -->
          <upload-question :isCardActive="uploadQuestion" :question="taskResults" :answer="answer" :predefinedComments="predefinedComments" />
        </div>
      </div>
    </div>
    
    <!-- Upload -->

    <div v-else-if="taskResults && taskResults.uploadTaskId">
      <upload-task-view  :isCardActive="uploadTaskView" :uploadTask="taskResults" />
    </div>

    <!-- Video Capture -->

    <div v-else-if="taskResults && taskResults.videoCaptureTaskId">
      <capture-task-view  :isCardActive="captureTaskView" :captureTask="taskResults" />
    </div>

    <!-- Filepond -->

    <vx-card v-if="taskResults && taskResults.uploadTaskId && ((isTeacher == 'true') || (isStudent == 'true')) && (canTeacherComplete(taskResults.statusId) || canUpdate(taskResults.statusId))" class="mt-3" title="Additional Uploads">
      <div class="colMiddle" v-if="canTeacherComplete(taskResults.statusId) || canUpdate(taskResults.statusId)">
        <vx-input-group>       
            <template slot="prepend">
              <div class="prepend-text input-group_prepend-slot-bg">
                <span><feather-icon class="pt-1" icon="UploadCloudIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>
            <file-pond
              id="filepond"
              ref="pond"
              :server="uploadLocation"
              :label-idle="canUpdate(taskResults.statusId) ? updatepondlable : initpondlable "
              :allow-multiple="true"
              allowPaste=false
              :instant-upload="true"
              @processfile="uploadComplete"
            />       
        </vx-input-group>
      </div>

      <vs-table ref="uploadsTable" single max-items="15" :data="taskResults.teacherFeedbackDocumentUrls" v-if="taskResults.teacherFeedbackDocumentUrls.length != 0">
        <div slot="header" class="mb-3 flex flex-wrap-reverse items-center flex-grow justify-between">
          <div class="flex flex-wrap-reverse items-center">
          </div>
        </div>

        <template slot-scope="{data}" >
          <vs-tr :data="taskResults.teacherFeedbackDocumentUrls" :key="indextr" v-for="(file, indextr) in data">
            <vs-td>
              <img :src="setFileThumb(file)" width=30px class="product-img" />
            </vs-td>
            <vs-td>
              <p class="product-name font-medium">{{ file.substring(file.lastIndexOf('/') + 1) }}</p>
            </vs-td>
            <vs-td>
              <vs-button color="success" class="float-right" type="filled" icon-pack="feather" icon="icon-download" @click.stop="downloadFile(file)"></vs-button>
            </vs-td>
            <vs-td>
              <vs-button color="danger" class="float-right" type="filled" icon-pack="feather" icon="icon-trash" @click.stop="fileRemoveUpdate(file)"></vs-button>
            </vs-td>
          </vs-tr>
        </template>
      
      </vs-table>
    </vx-card>

    <div>
      <snapshot-view :isCardActive="snapshotView && !(loadingView || errorLoadingView) && !(taskResults.uploadTaskId || taskResults.videoCaptureTaskId)" />
      <ispring-final-comment-view v-if="taskResults && !taskResults.quizId && !taskResults.uploadTaskId && !taskResults.videoCaptureTaskId" :isCardActive="ispringFinalCommentView && !(loadingView || errorLoadingView)" :totalScore="ispringTotalScore" :quizData="taskResults" :predefinedComments="predefinedComments" />
      <quiz-final-comment-view v-else-if="taskResults && taskResults.quizId" :isCardActive="quizFinalCommentView && !(loadingView || errorLoadingView)" :quizAchievedMarks="quizAchievedMarks" :quizInfo="taskResults" :quizTextTotal="quizTotalMarks" :predefinedComments="predefinedComments" :newQuizTotal="quizTotalMarks" />
      <upload-comment-view v-else-if="taskResults && taskResults.uploadTaskId" :isCardActive="uploadCommentView && !(loadingView || errorLoadingView)" :uploadTask="taskResults" :predefinedComments="predefinedComments" />
      <capture-comment-view v-else-if="taskResults && taskResults.videoCaptureTaskId" :isCardActive="captureCommentView && !(loadingView || errorLoadingView)" :captureTask="taskResults" :predefinedComments="predefinedComments" />
    </div>

    <div v-if="taskResults.length != 0" class="vx-row">
      <div class="vx-col flex-row">
        <h4>Remedial Count: <span>{{` ${remedialCount}/${remedialCount >2 ? `${remedialCount}` : '2'}`}}</span></h4>
      </div>
      <vs-spacer></vs-spacer>
      <div id="buttons-container" class="vx-col">
        <vs-button v-if="$acl.not.check('Teacher') && canDiscard(taskResults.statusId) && $getTaskAttempt() == false" color="danger" class="mr-3 vs-con-loading__container" ref="discardAssessmentButton" @click="discardAssessment">Discard Task</vs-button>
        <vs-button v-if="$acl.check('Teacher') && taskResults.statusId ==1  " color="danger" class="mr-3 vs-con-loading__container" ref="discardAssessmentButton" @click="discardAssessment">Discard Task</vs-button>
        <vs-button v-if="$acl.not.check('Teacher') && !cannotReturnToStudent(taskResults.statusId) && remedialCount >= 2" color="danger" class="mr-3 vs-con-loading__container" ref="returnToStudentButton" @click="confirmRemedialsPassedDue">NYC / Remedials Passed Due</vs-button>
        <vs-button v-if="$acl.not.check('Teacher') && canComplete(taskResults.statusId)" color="success" class="mr-3 vs-con-loading__container" ref="completeAssessmentButton" @click="taskResults.statusId != 13 ? showCompletePopup() : completeAssessment()">Complete Assessment (Competent)</vs-button>
        <vs-button v-if="$acl.not.check('Teacher') && !cannotReturnToStudent(taskResults.statusId)" color="warning" class="mr-3 vs-con-loading__container" ref="returnToStudentButton" @click="returnToStudent">{{`${remedialCount >= 2 ? 'Continue Remedials' : 'Return To Student  (Not yet Competent)'}`}}</vs-button>
        <vs-button v-if="$acl.check('Teacher') && canTeacherComplete(taskResults.statusId)" color="success" class="mr-3 vs-con-loading__container" ref="completeAssessmentButton" @click="teacherCompleteAssessment">Complete Assessment</vs-button>
        <vs-button v-if="$acl.check('Teacher') && canUpdate(taskResults.statusId)" color="success" class="mr-3 vs-con-loading__container" ref="updateAssessmentButton" @click="updateTask">Update Assessment</vs-button>
        <vs-button color="warning" type="border" class="mb-2" @click="closeTab">Cancel</vs-button>
      </div>
    </div>

    <vs-popup title="Are you sure?" :active.sync="isAllSummativeTaskAssessed">
      <p class="pb-2">All summative task has been assessed. Remember to upload feedback document.</p>
      <div class="mt-3">
        <vs-button color="success" class="float-right" @click="isAllSummativeTaskAssessed = false">Confirm</vs-button>
      </div>
    </vs-popup>

    <vs-popup title="Are you sure?" :active.sync="showCompletePopupActive">
      <p class="pb-2">Are you sure you want to complete the assessment?</p>
      <p class="pb-2">When selecting this option the student won't be able to make any further edits or return any comments</p>
      <div class="mt-3">
        <vs-button color="warning" class="float-right" @click="showCompletePopupActive = false">Cancel</vs-button>
        <vs-button color="success" class="mr-2 float-right" @click="completeAssessment">Confirm</vs-button>
      </div>
    </vs-popup>

    <vs-popup id="AssessorFeedbackDocument" fullscreen :button-close-hidden="true" title="Assessor Feedback Preview" :active.sync="assessorFeedbackPreviewPopup">
      <div class="assessorFeedbackSize" style="width: fit-content; margin:auto">
        <assessorFeedbackDocument :assessorFeedbackData="assessorFeedbackData" :taskResults="taskResults" :questionList="questionList" :assessorFeedback="assessorFeedback" @closeTab="getVarCCS" />
      </div>
    </vs-popup>
  </div>
</template>

<script>
import ispringQuizInfoView from "./assessmentviews/iSpringQuizInfoView.vue";
import multipleChoiceQuestion from "./assessmentviews/MultipleChoiceQuestion.vue";
import multipleResponseQuestion from "./assessmentviews/MultipleResponseQuestion.vue";
import textQuestion from "./assessmentviews/TextQuestion.vue";
import sequenceQuestion from "./assessmentviews/SequenceQuestion.vue";
import matchingQuestion from "./assessmentviews/MatchingQuestion.vue";
import sentenceQuestion from "./assessmentviews/SentenceQuestion.vue";
import likertScaleQuestion from "./assessmentviews/LikertScaleQuestion.vue";
import quizInfoView from "./assessmentviews/QuizInfoView.vue";
import mcssQuestion from "./assessmentviews/MCSSQuestion.vue";
import dragAndDrop from "./assessmentviews/DragAndDrop.vue";
import mcmsQuestion from "./assessmentviews/MCMSQuestion.vue";
import freeTextQuestion from "./assessmentviews/FreeTextQuestion.vue";
import uploadQuestion from "./assessmentviews/UploadQuestion.vue";
import tableQuestion from "./assessmentviews/TableQuestion.vue";
import uploadTaskView from "./assessmentviews/UploadTaskView.vue";
import captureTaskView from "./assessmentviews/CaptureTaskView.vue";
import snapshotView from "./assessmentviews/SnapshotsView.vue";
import loadingView from "./assessmentviews/ResultsLoadingView.vue";
import errorLoadingView from "./assessmentviews/ErrorLoadingView.vue";
import ispringFinalCommentView from "./assessmentviews/iSpringFinalCommentView.vue";
import quizFinalCommentView from "./assessmentviews/QuizFinalCommentView.vue";
import uploadCommentView from "./assessmentviews/UploadCommentView.vue";
import captureCommentView from "./assessmentviews/CaptureCommentView.vue";
import assessorFeedbackDocument from "../components/AssessorFeedbackDocument.vue";

import vueFilePond from 'vue-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);
import 'animate.css';
export default {
  components: {
    ispringQuizInfoView,
    multipleChoiceQuestion,
    multipleResponseQuestion,
    textQuestion,
    sequenceQuestion,
    matchingQuestion,
    sentenceQuestion,
    likertScaleQuestion,
    quizInfoView,
    mcssQuestion,
    mcmsQuestion,
    dragAndDrop,
    freeTextQuestion,
    tableQuestion,
    uploadTaskView,
    captureTaskView,
    snapshotView,
    loadingView,
    errorLoadingView,
    ispringFinalCommentView,
    quizFinalCommentView,
    uploadCommentView,
    captureCommentView,
    FilePond,
    uploadQuestion,
    assessorFeedbackDocument
  },
  data() {
    return {
      isMounted: false,
      taskLogId: null,
      taskResults: [],
      ispringQuizInfoView: true,
      multipleChoiceQuestion: true,
      multipleResponseQuestion: true,
      textQuestion: true,
      sequenceQuestion: true,
      matchingQuestion: true,
      sentenceQuestion: true,
      likertScaleQuestion: true,
      quizInfoView: true,
      mcssQuestion: true,
      mcmsQuestion: true,
      freeTextQuestion: true,
      uploadQuestion:true,
      tableQuestion: true,
      dragAndDropQuestion: true,
      uploadTaskView: true,
      captureTaskView: true,
      snapshotView: true,
      loadingView: false,
      errorLoadingView: false,
      ispringFinalCommentView: true,
      quizFinalCommentView: true,
      ispringTotalScore: 0,
      quizAchievedMarks: 0,
      quizTotalMarks: 0,
      uploadCommentView: true,
      captureCommentView: true,
      predefinedComments: [],
      uploadedFileUrlList: [],
      isAllSummativeTaskAssessed: false,
      isTeacher: false,
      isStudent: false,
      initpondlable: "Drop upload files here or <span class='filepond--label-action'>Browse</span>",
      updatepondlable: "Drop updated files here or <span class='filepond--label-action'>Browse</span>",
      showCompletePopupActive: false,
      outcome:[],
      standard:[],
      isModuleContinuous:false,
      assessorFeedback:{
        studentId:0,
        isCompetent:false,
        hasCompletedQuizzes:false,
        hasCompletedJournals:false,
        hasCompletedLogbook:false,
        hasCompletedPersonalInfo:false,
        hasCompletedAssessmentPrep:false,
        hasCompletedAssessmentPlan:false,
        hasCompletedDeclarationofAuth:false,
        logId:0,
        assessorFeedbackAnswers:[]
      },
      assessorFeedbackAnswer:{
        id:0,
        agree:null,
        answer:null
      },
      questionList:[],
      popupHtml:``,
      freeTextPopup:``,
      lastIndex:0,
      assessorFeedbackPreviewPopup:false,
      assessorFeedbackData:{},
      varccsItems:[],
      varccHTML:"",
      varccComment:"",
      studentModuleId:0,
      reviewQuestions:[],
      reviewHTML:"",
      remedialCount:0,
      sendToStudent:false,
    };
  },
  watch: {
    taskResults: {
      deep: true,
      handler() {
        var self = this;
        if(self.taskResults && !self.taskResults.quizId && !self.taskResults.uploadTaskId && !self.taskResults.videoCaptureTaskId){
          self.ispringTotalScore = 0;
          for(var i = 0; i < self.taskResults.questions.length; i++) {
            self.ispringTotalScore += parseInt(self.taskResults.questions[i].assessment.awardedPoints)
          }
        }
        else if(self.taskResults && self.taskResults.quizId){
          self.quizAchievedMarks = 0;
          self.quizTotalMarks = 0;
          for(var i = 0; i < self.taskResults.answers.length; i++) {
            self.quizAchievedMarks += self.taskResults.answers[i].questionAchievedMarks == "" ? 0 : parseInt(self.taskResults.answers[i].questionAchievedMarks)
          }

          for(var i = 0; i < self.taskResults.answers.length; i++) {
            self.quizTotalMarks += parseInt(self.taskResults.answers[i].questionTotalMarks)
          }

          for(var i = 0; i < self.taskResults.answers.length; i++) {
            self.quizTotalMarks += parseInt(self.taskResults.answers[i].textOriginalTotalPoints)
          }

          for(var i = 0; i < self.taskResults.answers.length; i++) {
            self.quizTotalMarks += parseInt(self.taskResults.answers[i].tableOriginalTotalPoints)
          }
        }
      }
    },
    isAllSummativeTaskAssessed: function(){
      var self = this;
      if(!self.isAllSummativeTaskAssessed)
      {
        self.closeTab();
      }
    }
  },
  computed: {
    uploadLocation: {
      get() {
        return this.$buildUrl("tempupload");
      }
    },
  },
  methods: {
    closeTab() {
      this.close();
    },
    close() {
      if(!this.$acl.check('Teacher')){
        if(window.opener){
          var btn = window.opener.document.getElementById("TaskViewRefreshButton");
          var taskProgressRefreshButton = window.opener.document.getElementById("TaskProgressRefreshButton");
          if (btn) {
            btn.click();
          }
          if (taskProgressRefreshButton) {
            taskProgressRefreshButton.click();
          }
        }
      }
      
      window.open("", "_self").close();
    },
    initValues() {
      this.isMounted = false;
      this.taskLogId = null;
      this.taskResults = [];
      this.errors.clear();
    },
    loadPredefinedComments(){
      const self = this;

      var onSuccess = function (response) {
        self.predefinedComments = response.data.map((item) => {return {label: item.text, value: item.value} });
      };

      self.$ajaxGet(self, "PredefinedComment/GetSelectList", onSuccess);
    },
    loadTask() {
      const self = this;
      self.loadingView = true;
      var onSuccess = function(response) {
        if (response.data) {
          self.taskResults = response.data;
        }
      };

      var onFinally = function() {
        self.loadingView = false;
        if (!self.loadingView && self.taskResults.length == 0)
          self.errorLoadingView = true;
      };
      self.$ajaxGet(self, "assessor/GetTask/" + self.$route.query.TaskLogId, onSuccess, onFinally);
    },
    returnToStudent() {
      var self = this;
      if(this.remedialCount >=2 && !this.sendToStudent){
        self.confirmReturnToStudent();
        return
      }
      if (self.$siteTypeId() != 1) {
        self.$swal({
          title: 'Attention',
          icon: 'warning',
          html: "<p class='mb-3'>Did you comment in the comment boxes where <strong>incorrect</strong> answers were provided?</p><p>Please make sure that positive comments are <strong>only</strong> used within the final comment box.</p>",
          customClass: {
            confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled mr-4',
            cancelButton: 'vs-component vs-button vs-button-warning vs-button-border',
          },
          showClass: {
            popup: 'animate__animated animate__bounceIn',
          },
          showCancelButton: true,
          buttonsStyling: false,
        }).then((result) => {
          if (result.isConfirmed) {
            self.doReturnToStudentApiCall();
          }
        });
      } else {
        self.doReturnToStudentApiCall();
      }
    },
    doReturnToStudentApiCall() {
      var self = this;

      self.showLoadingOnElement("returnToStudentButton", 0.45, "material");

      var onSuccess = response => {
        self.$vs.loading.close(self.$refs.returnToStudentButton.$el);
        self.closeTab();
      };

      var assessmentResult = {};
      assessmentResult.logId = self.$route.query.TaskLogId;

      if(self.taskResults && !self.taskResults.quizId && !self.taskResults.uploadTaskId && !self.taskResults.videoCaptureTaskId) {
        assessmentResult.assessment = self.taskResults.questions.map(function(item) {return item.assessment});
        assessmentResult.finalAssessorComment = self.taskResults.finalAssessorComment;
        assessmentResult.finalAchievedScore = self.ispringTotalScore;

        self.$ajaxPost(self, "ISpringQuizAssessment/ReturnAssessmentToStudent", assessmentResult, onSuccess);
      }
      else if(self.taskResults && self.taskResults.quizId) {
        assessmentResult.quizId = self.taskResults.quizId;
        assessmentResult.quizAnswers = self.taskResults.answers;
        assessmentResult.finalAssessorComment = self.taskResults.finalAssessorComment;
        assessmentResult.finalAchievedScore = self.quizAchievedMarks;
        assessmentResult.quizTotal = self.quizTotalMarks;

        self.$ajaxPost(self, "QuizAssessment/ReturnAssessmentToStudent", assessmentResult, onSuccess);
      }
      else if(self.taskResults && self.taskResults.uploadTaskId) {
        assessmentResult.achievedMarks = self.taskResults.achievedMarks;
        assessmentResult.totalMarks = self.taskResults.totalMarks;
        assessmentResult.assessorComment = self.taskResults.assessorComment;

        self.$ajaxPost(self, "UploadAssessment/ReturnAssessmentToStudent", assessmentResult, onSuccess);
      }
      else if(self.taskResults && self.taskResults.videoCaptureTaskId) {
        assessmentResult.achievedMarks = self.taskResults.achievedMarks;
        assessmentResult.totalMarks = self.taskResults.totalMarks;
        assessmentResult.assessorComment = self.taskResults.assessorComment;

        self.$ajaxPost(self, "CaptureAssessment/ReturnAssessmentToStudent", assessmentResult, onSuccess);
      }
    },
    completeAssessment() {
      var self = this;
      self.showCompletePopupActive= false;
      self.showLoadingOnElement("completeAssessmentButton", 0.45, "material");

      var onSuccess = response => {
        self.$vs.loading.close(self.$refs.completeAssessmentButton.$el);
        if(self.isModuleContinuous){
          self.showFinalJudgeMentPopup();
        }
        else{
          self.checkIfAllSummativeTaskAssessed();
        }
        //self.closeTab();
      };

      var assessmentResult = {};
      assessmentResult.logId = self.$route.query.TaskLogId;

      if(self.taskResults && !self.taskResults.quizId && !self.taskResults.uploadTaskId && !self.taskResults.videoCaptureTaskId) {
        assessmentResult.assessment = self.taskResults.questions.map(function(item) {return item.assessment});
        assessmentResult.finalAssessorComment = self.taskResults.finalAssessorComment;
        assessmentResult.finalAchievedScore = self.ispringTotalScore;

        self.$ajaxPost(self, "ISpringQuizAssessment/CompleteAssessment", assessmentResult, onSuccess);
      }
      else if(self.taskResults && self.taskResults.quizId) {
        assessmentResult.quizId = self.taskResults.quizId;
        assessmentResult.quizAnswers = self.taskResults.answers;
        assessmentResult.finalAssessorComment = self.taskResults.finalAssessorComment;
        assessmentResult.finalAchievedScore = self.quizAchievedMarks;
        assessmentResult.quizTotal = self.quizTotalMarks;

        self.$ajaxPost(self, "QuizAssessment/CompleteAssessment", assessmentResult, onSuccess);
      }
      else if(self.taskResults && self.taskResults.uploadTaskId) {
        assessmentResult.achievedMarks = self.taskResults.achievedMarks;
        assessmentResult.totalMarks = self.taskResults.totalMarks;
        assessmentResult.assessorComment = self.taskResults.assessorComment;

        self.$ajaxPost(self, "UploadAssessment/CompleteAssessment", assessmentResult, onSuccess);
      }
      else if(self.taskResults && self.taskResults.videoCaptureTaskId) {
        assessmentResult.achievedMarks = self.taskResults.achievedMarks;
        assessmentResult.totalMarks = self.taskResults.totalMarks;
        assessmentResult.assessorComment = self.taskResults.assessorComment;

        self.$ajaxPost(self, "CaptureAssessment/CompleteAssessment", assessmentResult, onSuccess);
      }
    },
    checkIfAllSummativeTaskAssessed(){
      var self = this;
      var onSuccess = response => {
        if(response.data == 10)
          self.showFinalJudgeMentPopup();
        else
          self.closeTab();
      }
      
      self.$ajaxGet(self, `StudentModule/GetStudentModuleStatusIdWithTaskLogId?taskLogId=${self.$route.query.TaskLogId}`, onSuccess);
    },
    discardAssessment() {
      var self = this;
      self.showLoadingOnElement("discardAssessmentButton", 0.45, "material");

      var onSuccess = response => {
        self.$vs.loading.close(self.$refs.discardAssessmentButton.$el);
        self.closeTab();
      };
      var onFinally = response => {
        if (self.$refs.discardAssessmentButton) {
          self.$vs.loading.close(self.$refs.discardAssessmentButton.$el);
        }
      };

      var assessmentResult = {};
      assessmentResult.logId = self.$route.query.TaskLogId;

      if(self.taskResults && !self.taskResults.quizId && !self.taskResults.uploadTaskId && !self.taskResults.videoCaptureTaskId) {
        assessmentResult.assessment = self.taskResults.questions.map(function(item) {return item.assessment});
        assessmentResult.finalAssessorComment = self.taskResults.finalAssessorComment;
        assessmentResult.finalAchievedScore = self.ispringTotalScore;

        self.$ajaxPost(self, "ISpringQuizAssessment/DiscardAssessment", assessmentResult, onSuccess, onFinally);
      }
      else if(self.taskResults && self.taskResults.quizId) {
        assessmentResult.quizId = self.taskResults.quizId;
        assessmentResult.quizAnswers = self.taskResults.answers;
        assessmentResult.finalAssessorComment = self.taskResults.finalAssessorComment;
        assessmentResult.finalAchievedScore = self.quizAchievedMarks;
        assessmentResult.quizTotal = self.quizTotalMarks;

        self.$ajaxPost(self, "QuizAssessment/DiscardAssessment", assessmentResult, onSuccess, onFinally);
      }
      else if(self.taskResults && self.taskResults.uploadTaskId) {
        assessmentResult.achievedMarks = self.taskResults.achievedMarks;
        assessmentResult.totalMarks = self.taskResults.totalMarks;
        assessmentResult.assessorComment = self.taskResults.assessorComment;

        self.$ajaxPost(self, "UploadAssessment/DiscardAssessment", assessmentResult, onSuccess, onFinally);
      }
      else if(self.taskResults && self.taskResults.videoCaptureTaskId) {
        assessmentResult.achievedMarks = self.taskResults.achievedMarks;
        assessmentResult.totalMarks = self.taskResults.totalMarks;
        assessmentResult.assessorComment = self.taskResults.assessorComment;

        self.$ajaxPost(self, "CaptureAssessment/DiscardAssessment", assessmentResult, onSuccess, onFinally);
      }
    },
    teacherCompleteAssessment() {
      var self = this;
      self.showLoadingOnElement("completeAssessmentButton", 0.45, "material");

      var onSuccess = response => {
        self.$vs.loading.close(self.$refs.completeAssessmentButton.$el);
        self.closeTab();
      };

      var assessmentResult = {};
      assessmentResult.logId = self.$route.query.TaskLogId;

      if(self.taskResults && !self.taskResults.quizId && !self.taskResults.uploadTaskId && !self.taskResults.videoCaptureTaskId) {
        assessmentResult.assessment = self.taskResults.questions.map(function(item) {return item.assessment});
        assessmentResult.finalAssessorComment = self.taskResults.finalAssessorComment;
        assessmentResult.finalAchievedScore = self.ispringTotalScore;

        self.$ajaxPost(self, "ISpringQuizAssessment/TeacherCompleteAssessment", assessmentResult, onSuccess);
      }
      else if(self.taskResults && self.taskResults.quizId) {
        assessmentResult.quizId = self.taskResults.quizId;
        assessmentResult.quizAnswers = self.taskResults.answers;
        assessmentResult.finalAssessorComment = self.taskResults.finalAssessorComment;
        assessmentResult.finalAchievedScore = self.quizAchievedMarks;
        assessmentResult.quizTotal = self.quizTotalMarks;

        self.$ajaxPost(self, "QuizAssessment/TeacherCompleteAssessment", assessmentResult, onSuccess);
      }
      else if(self.taskResults && self.taskResults.uploadTaskId) {
        assessmentResult.achievedMarks = self.taskResults.achievedMarks;
        assessmentResult.totalMarks = self.taskResults.totalMarks;
        assessmentResult.assessorComment = self.taskResults.assessorComment;
        assessmentResult.teacherFeedbackDocumentUrls = self.taskResults.teacherFeedbackDocumentUrls;

        self.$ajaxPost(self, "UploadAssessment/TeacherCompleteAssessment", assessmentResult, onSuccess);
      }
      else if(self.taskResults && self.taskResults.videoCaptureTaskId) {
        assessmentResult.achievedMarks = self.taskResults.achievedMarks;
        assessmentResult.totalMarks = self.taskResults.totalMarks;
        assessmentResult.assessorComment = self.taskResults.assessorComment;

        self.$ajaxPost(self, "CaptureAssessment/TeacherCompleteAssessment", assessmentResult, onSuccess);
      }
    },
    scrollToNavbar() {
      var scrollOptions = {
        easing: "ease-in",
        offset: -500,
        force: true,
        cancelable: true,
        x: false,
        y: true
      };
      var cancelScroll = this.$scrollTo(document.getElementById("navbarGlobal"), 500, scrollOptions);
    },
    showLoadingOnElement(element, scale, type){
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    canDiscard(statusId){
      if(statusId === 1)
        return true;

      return false;
    },
    canComplete(statusId){
      if(statusId === 13 || statusId === 17 || statusId === 14 || statusId ===1 || statusId ===5)
        return true;

      return false;
    },
    cannotReturnToStudent(statusId){
      if(statusId === 2)
        return true;
      
      return false;
    },
    canTeacherComplete(statusId){
      if(statusId === 1)
        return true;

      return false;
    },
    canReturnToStudent(statusId){
      if(statusId === 17 || statusId === 14)
        return false;

      return true;
    },
    canUpdate(statusId){
      if(statusId === 24)
        return true;

      return false;
    },
    uploadComplete(error, file) {
      var self = this;

      var response = JSON.parse(file.serverId);
      self.taskResults.teacherFeedbackDocumentUrls.push(response.url);

      var allFinished = self.$refs.pond.getFiles().filter(x => x.status !== 5);

      self.$refs.pond.removeFile(file);

      self.clearlastfile(allFinished);
    },
    clearlastfile(allFinished){
      if((allFinished.length == 0)){
          self.$refs.pond.removeFiles();
      }
    },
    // fileRemove(error, file) {
    //   var self = this;

    //   var fileName =  file.file.name;
    //   var code = "";

    //   self.taskResults.teacherFeedbackDocumentUrls.forEach(element => {
    //     if(element.includes(fileName))
    //       code = element;
    //   });

    //   var index = self.taskResults.teacherFeedbackDocumentUrls.indexOf( code );

    //   self.taskResults.teacherFeedbackDocumentUrls.splice(index, 1)
    // },
    downloadFile(file){
      window.open(file);
    },
    setFileThumb(url) {
      var ext = url.substring(url.lastIndexOf('.') + 1);
      if (ext.includes('mp3'))
        return "https://forty5degreesstorage.blob.core.windows.net/assets/music.jpg";
      else if (ext.includes('jpg') || ext.includes('jpeg') || ext.includes('png') || ext.includes('gif') || ext.includes('PNG'))
        return "https://forty5degreesstorage.blob.core.windows.net/assets/image.png";
      else if (ext.includes('doc') || ext.includes('xls') || ext.includes('pdf') || ext.includes('ppt') || ext.includes('txt') || ext.includes('rtf'))
        return "https://forty5degreesstorage.blob.core.windows.net/assets/document.png";
      else if (ext.includes('mp4') || ext.includes('wmv') || ext.includes('mov') || ext.includes('webm') || ext.includes('x-matroska') || ext.includes('mkv'))
        return "https://forty5degreesstorage.blob.core.windows.net/assets/video.png";
    },
    fileRemoveUpdate(file){
      var self = this;

      var index = self.taskResults.teacherFeedbackDocumentUrls.indexOf( file );

      self.taskResults.teacherFeedbackDocumentUrls.splice(index, 1)
    },
    updateTask(){
      var self = this;
      self.showLoadingOnElement("updateAssessmentButton", 0.45, "material");

      var onSuccess = response => {
        self.$vs.loading.close(self.$refs.updateAssessmentButton.$el);
        self.closeTab();
      };

      var assessmentResult = {};
      assessmentResult.logId = self.$route.query.TaskLogId;

      if(self.taskResults && !self.taskResults.quizId && !self.taskResults.uploadTaskId && !self.taskResults.videoCaptureTaskId) {
        assessmentResult.assessment = self.taskResults.questions.map(function(item) {return item.assessment});
        assessmentResult.finalAssessorComment = self.taskResults.finalAssessorComment;
        assessmentResult.finalAchievedScore = self.ispringTotalScore;

        self.$ajaxPost(self, "ISpringQuizAssessment/TeacherUpdateAssessment", assessmentResult, onSuccess);
      }
      else if(self.taskResults && self.taskResults.quizId) {
        assessmentResult.quizId = self.taskResults.quizId;
        assessmentResult.quizAnswers = self.taskResults.answers;
        assessmentResult.finalAssessorComment = self.taskResults.finalAssessorComment;
        assessmentResult.finalAchievedScore = self.quizAchievedMarks;
        assessmentResult.quizTotal = self.quizTotalMarks;

        self.$ajaxPost(self, "QuizAssessment/TeacherUpdateAssessment", assessmentResult, onSuccess);
      }
      else if(self.taskResults && self.taskResults.uploadTaskId) {
        assessmentResult.achievedMarks = self.taskResults.achievedMarks;
        assessmentResult.totalMarks = self.taskResults.totalMarks;
        assessmentResult.assessorComment = self.taskResults.assessorComment;
        assessmentResult.teacherFeedbackDocumentUrls = self.taskResults.teacherFeedbackDocumentUrls;

        self.$ajaxPost(self, "UploadAssessment/TeacherUpdateAssessment", assessmentResult, onSuccess);
      }
      else if(self.taskResults && self.taskResults.videoCaptureTaskId) {
        assessmentResult.achievedMarks = self.taskResults.achievedMarks;
        assessmentResult.totalMarks = self.taskResults.totalMarks;
        assessmentResult.assessorComment = self.taskResults.assessorComment;

        self.$ajaxPost(self, "CaptureAssessment/TeacherUpdateAssessment", assessmentResult, onSuccess);
      }
    },
    showCompletePopup(){
      var self = this;
      self.showCompletePopupActive= true;
    },
    getStandardsAndOutcomes(){
      var self = this;
      var onSuccess = response =>{
        self.standard = response.data.standard;
        self.outcome = response.data.outcome;
      }
    
      var onFinally = response =>{
        if(self.$refs.whole_Page){
        }
      }
      //self.$route.query.TaskLogId
      self.$ajaxGet(self, "Course/GetOutcomeInfo/" + self.$route.query.TaskLogId , onSuccess, onFinally);
    },
    checkModuleContinuousAndLastTask(){
      var self = this;

      var onSuccess = response =>{
        self.isModuleContinuous = response.data;
      }
    
      self.$ajaxGet(self, `Assessor/ContinuousModuleCheck/${self.$route.query.TaskLogId}` , onSuccess);
    },
    firstReviewPopUp(){
      var self = this;
      self.$swal({
        title: 'Feedback',
        icon: 'info',
        html: `
        <h4>Check the following</h4>
        <div class="popupCustomContent mb-3">
          <div class="pretty p-default p-round p-fill float-left mb-3">
            <input type="checkbox" class="check_container" id="FeedbackQuizzes" name="Quizzes" checked>
            <div class="state p-success">
              <label for="FeedbackQuizzes">Quizzes</label><br>
            </div>
          </div>

          <div class="pretty p-default p-round p-fill float-left mb-3">
            <input type="checkbox" class="check_container" id="FeedbackJournals" name="Journals & Case Studies" checked>
            <div class="state p-success">
              <label for="FeedbackJournals">Journals & Case Studies</label><br>
            </div>
          </div>

          <div class="pretty p-default p-round p-fill float-left mb-3">
            <input type="checkbox" class="check_container" id="FeedbackLogbook" name="Workplace Logbook" checked>
            <div class="state p-success">
              <label for="FeedbackLogbook">Workplace Logbook</label><br>
            </div>
          </div>

          <div class="pretty p-default p-round p-fill float-left mb-3">
            <input type="checkbox" class="check_container" id="FeedbackPersonalInformation" name="Learner’s Personal Information" checked>
            <div class="state p-success">
              <label for="FeedbackPersonalInformation">Learner’s Personal Information</label><br>
            </div>
          </div>

          <div class="pretty p-default p-round p-fill float-left mb-3">
            <input type="checkbox" class="check_container" id="FeedbackPreparation" name="Assessment Preparation" checked>
            <div class="state p-success">
              <label for="FeedbackPreparation">Assessment Preparation</label><br>
            </div>
          </div>

          <div class="pretty p-default p-round p-fill float-left mb-3">
            <input type="checkbox" class="check_container" id="FeedbackAssessmentPlan" name="Assessment Plan" checked>
            <div class="state p-success">
              <label for="FeedbackAssessmentPlan">Assessment Plan</label><br>
            </div>
          </div>

          <div class="pretty p-default p-round p-fill float-left mb-3">
            <input type="checkbox" class="check_container" id="FeedbackAuthenticity" name="Declaration of Authenticity" checked>
            <div class="state p-success">
              <label for="FeedbackAuthenticity">Declaration of Authenticity</label><br>
            </div>
          </div>
        </div>`,
        customClass: {
          confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled mr-4 btn-next',
        },
        showClass: {
          popup: 'animate__animated animate__bounceIn assessment-Questions',
        },
        confirmButtonText:'Next',
        showCancelButton: true,
        buttonsStyling: false,
        allowOutsideClick:false,
        allowEnterKey:false,
        allowEscapeKey:false,
        showCancelButton:false,

        preConfirm:(data) =>{
          this.assessorFeedback.hasCompletedQuizzes = document.getElementById('FeedbackQuizzes').checked ;
          this.assessorFeedback.hasCompletedJournals = document.getElementById('FeedbackJournals').checked ;
          this.assessorFeedback.hasCompletedLogbook = document.getElementById('FeedbackLogbook').checked ;
          this.assessorFeedback.hasCompletedPersonalInfo = document.getElementById('FeedbackPersonalInformation').checked ;
          this.assessorFeedback.hasCompletedAssessmentPrep = document.getElementById('FeedbackPreparation').checked ;
          this.assessorFeedback.hasCompletedAssessmentPlan = document.getElementById('FeedbackAssessmentPlan').checked ;
          this.assessorFeedback.hasCompletedDeclarationofAuth = document.getElementById('FeedbackAuthenticity').checked ;
          
        },
      }).then((result) => {
        self.addAssessorFeedback();
      });
    },
    showFinalJudgeMentPopup(){
      var self = this;
      self.$swal({
        title: 'Final Judgement',
        icon: 'warning',
        html: `<p class='mb-3'>What is your final judgement on <br> <strong>${self.taskResults.fullname}'s</strong> compentency?</p>`,
        customClass: {
          confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled mr-4',
          cancelButton: 'vs-component vs-button vs-button-warning vs-button-filled',
        },
        showClass: {
          popup: 'animate__animated animate__bounceIn',
        },
        confirmButtonText:'Competent',
        cancelButtonText:'Not Yet Competent',
        showCancelButton: true,
        showCloseButton: true,
        buttonsStyling: false,
        allowOutsideClick:false,
        allowEnterKey:false,
        allowEscapeKey:false,
      }).then((result) => {
        console.log(result)
        if((result.dismiss == "close") || (result.value == false)){
          self.closeTab();
        }
        else{
          if (result.isConfirmed) {
            self.assessorFeedback.isCompetent = true;
          }
          else{
            self.assessorFeedback.isCompetent = false;
          }
          self.firstReviewPopUp();
        }
      });
    },
    addAssessorFeedback(){
      var self = this;
      self.showLoadingOnElement("whole_page",1,"corners");

      var onSuccess = response =>{

        if(self.$refs.whole_page){
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
        //Send to other popups
        self.assessorFeedbackData = response.data;
        self.assessorFeedbackPreviewPopup  = true;
      }
      self.assessorFeedback.logId = self.$route.query.TaskLogId;
      self.$ajaxPost(self, "assessor/FeedbackDocument" , self.assessorFeedback , onSuccess);
    },
    getVarCCS(){
      var self = this;
      self.showLoadingOnElement("whole_page",1,"corners");

      var onSuccess = response =>{
        self.varccsItems = response.data;
        self.varcPopupHTMLGen();
      }
    
      var onFinally = response =>{
        if(self.$refs.whole_page){
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      }
    
      self.$ajaxGet(self, `Assessor/varcQuestions?logId=${self.$route.query.TaskLogId}` , onSuccess, onFinally);
    },
    varcPopupHTMLGen(){
      var self = this;
      self.assessorFeedbackPreviewPopup  = false;
      self.varccHTML = "";
      self.varccComment = "";
      for (let index = 0; index < self.varccsItems.length; index++) {
        self.varccHTML += `
        <div class="Heading mb-3">
          <p><span>${self.varccsItems[index].id}. </span>${self.varccsItems[index].question}</p>
        </div>
        <div class="vx-row checkbox-relative">
          <div class="pretty p-default p-round p-fill float-left mb-3 vx-col" style="align-self:center;">
            <input type="checkbox" class="check_container" checked id="varcccheck${self.varccsItems[index].id}">
            <div class="state p-success">
              <label for="varcccheck${self.varccsItems[index].id}"> Agree</label><br>
            </div>
          </div>
          <div class="vx-col w-2/3">
            <div class="vs-component vs-con-textarea vs-textarea-primary">
              <textarea placeholder="Description" id="varcccomment${self.varccsItems[index].id}" class="vs-textarea">${self.varccsItems[index].comment ? self.varccsItems[index].comment : ''}</textarea> 
            </div>
          </div>
        </div>
        `;
        self.lastIndex = index;
      };
      self.showpopupVarcCheck();
    },
    showpopupVarcCheck(){
      var self = this;
      self.$swal({
        title: 'VARCCS Evaluation',
        icon: 'info',
        html: `
        <h4>Answer the following</h4>
        <div class="popupCustomContent mb-3">
          ${self.varccHTML}
        </div>`,
        customClass: {
          confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled mr-4',
        },
        showClass: {
          popup: 'animate__animated animate__fadeInDown varccs-evaluation',
        },
        confirmButtonText:'Next',
        showCancelButton: true,
        buttonsStyling: false,
        allowOutsideClick:false,
        allowEnterKey:false,
        allowEscapeKey:false,
        showCancelButton:false,
        preConfirm:(data) =>{
          for (let index = 0; index < self.varccsItems.length ; index++) {
            var generatedCheckId = `varcccheck${self.varccsItems[index].id}`
            var generatedCommentId = `varcccomment${self.varccsItems[index].id}`
            var check = document.getElementById(generatedCheckId).checked;
            var comment = document.getElementById(generatedCommentId).value;
            self.varccsItems[index].answer = check;
            self.varccsItems[index].comment = comment;
          }
        },
      }).then((result) => {
        self.returnVarccs();
      });
    },
    returnVarccs(){
      var self = this;
      self.showLoadingOnElement("whole_page",1,"corners");

      var onSuccess = response =>{
        self.studentModuleId = response.data;
        self.getReviewQuestions();
      }
    
      var onFinally = response =>{
        if(self.$refs.whole_page){
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      }
    
      self.$ajaxPost(self, `Assessor/ReturnVarcResponse?logId=${self.$route.query.TaskLogId}` , self.varccsItems , onSuccess, onFinally);
    },
    getReviewQuestions(){
      var self = this;
      self.showLoadingOnElement("whole_page",1,"corners");
      var onSuccess = response =>{
        self.reviewQuestions = response.data;
        self.varcReviewHtml();
      }
    
      var onFinally = response =>{
        if(self.$refs.whole_page){
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      }
    
      self.$ajaxGet(self, `Assessor/ReviewQuestions?studentModuleId=${self.studentModuleId}` , onSuccess, onFinally);
    },
    varcReviewHtml(){
      var self = this;
      self.reviewHTML = "";
      for (let index = 0; index < self.reviewQuestions.length; index++) {
        self.reviewHTML += `
        <div class="Heading mb-3">
          <p><span>${self.reviewQuestions[index].questionId}. </span>${self.reviewQuestions[index].question}</p>
        </div>
        <div class="vx-row checkbox-relative">
          <div class="pretty p-default p-round p-fill float-left mb-3 vx-col" style="align-self:center;">
            <input type="checkbox" class="check_container" checked id="varcccheck${self.reviewQuestions[index].questionId}">
            <div class="state p-success">
              <label for="varcccheck${self.reviewQuestions[index].questionId}"> Agree</label><br>
            </div>
          </div>
          <div class="vx-col w-2/3">
            <div class="vs-component vs-con-textarea vs-textarea-primary">
              <textarea placeholder="Description" id="varcccomment${self.reviewQuestions[index].questionId}" class="vs-textarea">${self.reviewQuestions[index].assessorComment ? self.reviewQuestions[index].assessorComment : ''}</textarea> 
            </div>
          </div>
        </div>
        `;
        self.lastIndex = index;
      };
      self.showpopupReview();
    },
    showpopupReview(){
      var self = this;
      self.$swal({
        title: 'Review of the Assessment',
        icon: 'info',
        html: `
        <h4>Answer the following</h4>
        <div class="popupCustomContent mb-3">
          ${self.reviewHTML}
        </div>`,
        customClass: {
          confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled mr-4',
        },
        showClass: {
          popup: 'animate__animated animate__fadeInDown varccs-evaluation',
        },
        confirmButtonText:'Complete',
        showCancelButton: true,
        buttonsStyling: false,
        allowOutsideClick:false,
        allowEnterKey:false,
        allowEscapeKey:false,
        showCancelButton:false,
        preConfirm:(data) =>{
          for (let index = 0; index < self.reviewQuestions.length ; index++) {
            var generatedCheckId = `varcccheck${self.reviewQuestions[index].questionId}`
            var generatedCommentId = `varcccomment${self.reviewQuestions[index].questionId}`
            var check = document.getElementById(generatedCheckId).checked;
            var comment = document.getElementById(generatedCommentId).value;
            self.reviewQuestions[index].assessorResponse = check;
            self.reviewQuestions[index].assessorComment = comment;
          }
        },
      }).then((result) => {
        self.returnReview();
      });
    },
    returnReview(){
      var self = this;
      self.showLoadingOnElement("whole_page",1,"corners");

      var onSuccess = response =>{
        self.closeTab();
      }
    
      var onFinally = response =>{
        if(self.$refs.whole_page){
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      }
    
      self.$ajaxPost(self, `Assessor/UpdateReviewAnswers?studentmoduleId=${self.studentModuleId}`, self.reviewQuestions , onSuccess, onFinally);
    },
    getRemedialCount(){
      var self = this;
      var onSuccess = response =>{
        self.remedialCount = response.data;
      }
    
      self.$ajaxGet(self, `CourseTaskLog/GetRemedialCount/${self.$route.query.TaskLogId}` , onSuccess);
    },
    confirmReturnToStudent(){
      var self = this;
      self.$swal({
        title: 'Attention',
        icon: 'warning',
        html: "<p class='mb-3'>Are you sure you want to return this task to the student for <strong>Another Remedial Attempt</strong></p>",
        customClass: {
          confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled mr-4',
          cancelButton: 'vs-component vs-button vs-button-warning vs-button-border',
        },
        showClass: {
          popup: 'animate__animated animate__bounceIn',
        },
        showCancelButton: true,
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          self.sendToStudent = true;
          self.doReturnToStudentApiCall();
        }
      });
    },
    remedialsPassedDue(){
      var self = this;
      self.showLoadingOnElement("whole_page",1,"corners");
      var onSuccess = response =>{
        self.closeTab();
      }
    
      var onFinally = response =>{
        if(self.$refs.whole_page){
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      }
    
      self.$ajaxGet(self, `CourseTaskLog/RemedialsPassedDue/${self.$route.query.TaskLogId}` , onSuccess, onFinally);
    },
    confirmRemedialsPassedDue(){
      var self = this;
      self.$swal({
        title: 'Attention',
        icon: 'warning',
        html: "<p>By marking this task <strong>NYC / Remedials Passed Due </strong></p><p>no more remedial attempts will be permitted and this task will receive a status of <strong>Remedials Passed Due</strong></p>",
        customClass: {
          confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled mr-4',
          cancelButton: 'vs-component vs-button vs-button-warning vs-button-border',
        },
        showClass: {
          popup: 'animate__animated animate__bounceIn',
        },
        showCancelButton: true,
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          self.remedialsPassedDue();
        }
      });
    }
  },
  mounted() {
    var self = this;

    self.isTeacher = localStorage.getItem("isTeacher");
    self.isStudent = localStorage.getItem('isStudent');
    
    self.loadTask();
    self.loadPredefinedComments();
    self.getStandardsAndOutcomes();
    self.isMounted = true;
    self.checkModuleContinuousAndLastTask();
    self.getRemedialCount();
  }
}
</script>
<style lang="scss">
@media screen and (max-width: 644px) {
  #buttons-container {
    margin-top: 20px;
    margin-left: auto;
    margin-right: auto;
  }
}

.filepond--panel-root {
  border-radius: 0 6px 6px 0;
  background-color: #262c49 !important;
}

.filepond--drop-label {
  color:rgb(202, 202, 202) !important;
}

.colMiddle {
    width: 80%;
    margin: 0 auto;
    width: 500px !important;
}

#filepond{
  margin: 0 !important;
}

.filepond--wrapper {
  width: 100%;
}
.AssessorPopUp{
  margin: auto;
  width: fit-content;
  .Review-Dimensions-free{
    width: 100%;
  }
}
.assessment-Questions{
  width: fit-content !important;
  .popupCustomContent{
    width: fit-content;
    height: fit-content;
    display: flex;
    flex-direction: column;
    text-align: left;
  }
}
.checkbox-relative{
  .pretty .state label{
    position: relative !important;
  }
}

.varccs-evaluation{
  width: 50% !important;
  .popupCustomContent{
    height: fit-content;
    display: flex;
    flex-direction: column;
    text-align: left;
  }
}
</style>
